import React, { useEffect, useState } from 'react';
import { mdiChartBar, mdiFormDropdown } from '@mdi/js';
import Icon from '@mdi/react';
import { useHistory, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import P from 'router/paths';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';

const items = [
  {
    label: 'P&L Report',
    url: P.PNL_REPORT.INDEX,
    key: 'chart',
    icon: <Icon path={mdiChartBar} />,
  },
  {
    label: 'Custom Cost',
    key: 'crm',
    url: P.PNL_REPORT.CUSTOM_COST,
    icon: <Icon path={mdiFormDropdown} />,
  },
];

const PnLMainMenu = ({ dateRangeComponent }) => {
  const { queryParams } = useWidgetDate('global');

  const [selected, setSelected] = useState();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const key = items.find((item) => item.url === location.pathname)?.key;
    setSelected(key);
  }, [location.pathname]);

  const onSelect = ({ key }) => {
    const selectedItem = items.find((item) => item.key === key);
    if (selectedItem) {
      history.push(selectedItem.url + queryParams);
      setSelected(key);
    }
  };

  return (
    <div className='flex px-4 pr-8 items-center justify-between flex-col sm:flex-row gap-2 pt-1'>
      <Menu
        className='w-full order-1 sm:order-0 !border-none'
        mode='horizontal'
        selectedKeys={[selected]}
        onSelect={onSelect}
        items={items}
      />
      <div className='sm:max-w-44 order-0 sm:order-1 w-full'>{dateRangeComponent}</div>
    </div>
  );
};
export default PnLMainMenu;
